"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var Youtubestudio = function Youtubestudio(props) {
  var color = props.color,
      size = props.size,
      others = _objectWithoutPropertiesLoose(props, ["color", "size"]);

  return _react.default.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    fill: color,
    viewBox: "0 0 24 24"
  }, others), _react.default.createElement("path", {
    d: "M9.577 15.606L15.606 12 9.577 8.394zm11.38-2.423l2.536 1.972q.394.282.113.789l-2.423 4.169q-.225.394-.732.225l-2.986-1.183q-1.183.845-2.028 1.183l-.451 3.155q-.113.507-.563.507H9.577q-.45 0-.563-.507l-.45-3.155q-1.071-.45-2.029-1.183L3.55 20.338q-.507.169-.732-.225l-2.423-4.17q-.281-.506.113-.788l2.535-1.972Q2.986 12.79 2.986 12t.056-1.183L.507 8.845q-.394-.282-.113-.789l2.423-4.169q.225-.394.732-.225l2.986 1.183Q7.718 4 8.563 3.662L9.014.507Q9.127 0 9.577 0h4.846q.45 0 .563.507l.45 3.155q1.071.45 2.029 1.183l2.986-1.183q.507-.169.732.225l2.423 4.17q.281.506-.113.788l-2.535 1.972q.056.394.056 1.183t-.056 1.183Z"
  }));
};

Youtubestudio.propTypes = {
  /**
   * Hex color or color name
   */
  color: _propTypes.default.string,

  /**
   * The size of the Icon.
   */
  size: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number])
};
Youtubestudio.defaultProps = {
  color: 'currentColor',
  size: '24'
};
var _default = Youtubestudio;
exports.default = _default;